var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-box" },
    [
      _vm.label !== null
        ? _c("label", { staticClass: "label-text" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("validation-provider", {
        ref: "validationInput",
        attrs: { name: "baseInputEditValidationProvider", rules: _vm.rules },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              var valid = ref.valid
              return [
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: errors.length > 0 ? "error" : "",
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.displayModel,
                          expression: "displayModel",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { id: "", cols: "30", rows: "2" },
                      domProps: { value: _vm.displayModel },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.displayModel = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("small", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(errors[0])),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }